{
  "id": "campaign-144",
  "name": "Weedy Hillside",
  "seed": "campaign:144",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,,,,,,,,,,,,",
    ",,,,,,,,...,,,#,,,",
    ",,,,T,,..#......,,",
    ",,,,,,,T........,,",
    ",,,T,,,.........T,",
    ",,,,,,,T..#,,#,,,,",
    ",,,,,,,,,,,,h,..x,",
    ",,,,,,,,,,,~,.....",
    ",,,Y,,,h,,~~~....,",
    ",,,,,,,,,,,,,,,,#,",
    "...,,,,,,,,,,,,,,,",
    "....,,,,,,T,,,,,,,",
    "T...T,,,,*,#,,,,,,",
    "....,,,,**,,,,,,,,",
    "..h,,,,,,*,,,,,,,,",
    ",T,,,,T,,,,,,,,,,,",
    "..,,,,,,,,,,,,,,,,",
    "S...,,,,,,,,,,,,,,"
  ],
  "critters": [
    {
      "kind": "fox",
      "x": 2,
      "y": 11
    },
    {
      "kind": "fox",
      "x": 13,
      "y": 2
    },
    {
      "kind": "fox",
      "x": 14,
      "y": 6
    },
    {
      "kind": "fox",
      "x": 9,
      "y": 3
    },
    {
      "kind": "deer",
      "x": 17,
      "y": 7
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 4
    },
    {
      "kind": "gas",
      "x": 12,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 12,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 0
    },
    {
      "kind": "rare",
      "x": 11,
      "y": 8
    }
  ],
  "hills": [
    {
      "x": 13,
      "y": 2,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 144,
  "biome": "meadow",
  "par": {
    "reel": 12818,
    "push": 11326,
    "selfPropelled": 10160,
    "tractor": 8471,
    "zeroTurn": 7343,
    "fairway": 4191
  },
  "goldTime": {
    "reel": 12818,
    "push": 11326,
    "selfPropelled": 10160,
    "tractor": 8284,
    "zeroTurn": 7343,
    "fairway": 3687
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 5,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 17
    },
    "gold": {
      "reel": 0,
      "push": 5,
      "selfPropelled": 0,
      "tractor": 25,
      "zeroTurn": 0,
      "fairway": 43
    }
  }
}
